import { EventBus } from "../../../eventbus";
import {
  userHasAllRights,
  userHasSomeRights,
} from "../../../functions/userRights";

export default {
  props: {
    buttons: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    goTo(link, e) {
      e.preventDefault();

      this.$router.push(link);
    },
    emit(name, data, e) {
      e.preventDefault();

      EventBus.$emit(name, data);
    },

    checkRights(btn) {
      if (btn.rights) {
        //has rights so check if they are matched
        if (btn.needsSomeRights) {
          //only some rights needed
          return userHasSomeRights(btn.rights, this);
        } else {
          //needs all the rights
          return userHasAllRights(btn.rights, this);
        }
      } else {
        //has no right so is okey by default
        return true;
      }
    },
  },
};
